import { FC } from 'react';
import { KTSVG } from '../../../_metronic/helpers';

const styles = {
  borderRadius: '0.475rem',
  boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
  backgroundColor: '#fff',
  color: '#7e8299',
  fontWeight: '500',
  margin: '0',        
  width: 'auto',
  padding: '1rem 2rem 1rem 1rem',
  top: 'calc(50% - 2rem)',
  left: 'calc(50% - 6rem)',       
   
}

type Props = {
  display: boolean
  status_text?: string    
}

export const LoadingIndicator: FC<Props> = ({ display, status_text }) => {

  const text = status_text || 'Processing';
  
  if (! display) {
    return null;
  }

  return (
  <div className="d-flex flex-row align-items-center gap-3" style={{...styles, position: 'fixed', textAlign: 'center', zIndex: 8000}}>
    <KTSVG path='/media/icons/duotune/abstract/abs013.svg' className='svg-icon-2x animation-rotate' />
    <span>
      {text}
      &nbsp;&#8230;&nbsp;                
    </span>
  </div>
  )
};
